import { render } from "./pageDefault.vue?vue&type=template&id=d1f3ddfe&scoped=true"
import script from "./pageDefault.vue?vue&type=script&lang=js"
export * from "./pageDefault.vue?vue&type=script&lang=js"

import "./pageDefault.vue?vue&type=style&index=0&id=d1f3ddfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f3ddfe"]])

export default __exports__